<template>
	<div class="results">
		<table v-if="!showMessage">
			<tbody>
				<tr>
					<th>Zeitpreis:</th>
					<td class="value">{{ formatPrice(prices.time) }}</td>
				</tr>
				<tr>
					<th>Kilometerpreis:</th>
					<td class="value">{{ formatPrice(prices.distance) }}</td>
				</tr>
			</tbody>
			<tfoot>
				<tr>
					<th>Gesamtpreis:</th>
					<td class="value">{{ formatPrice(prices.sum) }}</td>
				</tr>
			</tfoot>
		</table>
		<div v-else>
			Für eine Buchungsdauer über {{ maxDurationDays }} Tage kann der Preis hier nicht errechnet werden.
		</div>
	</div>
</template>

<script>
import config from '../config';

export default {
	data () {
		return {
			maxDurationDays: config.timerange.maxDurationDays
		}
	},
	computed: {
		prices () {
			return this.$store.getters.getPrices;
		},
		showMessage () {
			if (this.$store.getters.isNoPriceAvailable) {
				return true;
			} else {
				return false;
			}
		}
	},
	methods: {
		formatPrice (price) {
			return parseFloat((price / 100).toFixed(2)).toLocaleString(window.navigator.language || 'de-DE', {
				style: 'currency',
				currency: 'EUR',
				minimumFractionDigits: 2
			});
		}
	}
}
</script>

<style scoped lang="scss">

.results {
	width: 315px;
	margin: 30px auto;
}
table {
	table-layout: fixed;
	width: 100%;
	text-align: right;
	font-size: 1rem;
	line-height: 1.5rem;
	border-collapse: collapse;
}
th {
	text-align: left;
	color: $color-label;
	font-weight: normal;
}
td {
	text-align: right;
	margin-left: 20px;
	color: $color-text;
	font-weight: normal;
}
tfoot {
	border-top: 1px solid black;
	font-weight: bold;
}
tbody tr:last-child > * {
	padding-bottom: .8rem;
}
tfoot tr > * {
	padding-top: 1.1rem;
}
tfoot td {
	font-weight: bold;
	font-size: 1rem;
}
</style>
